module.exports = __webpack_public_path__ + "static/media/wordmark-animation-black.c205d831.png";